import { useEffect, useRef, useState } from 'react';
import {
  DEFAULT_FORMATION_COVER_PATH,
  resolveFormationCoverUrl,
} from '@/lib/eduflow-formation-cover';
import { cn } from '@/lib/utils';

interface Props {
  coverImageUrl?: string | null;
  alt?: string;
  className?: string;
  fallback?: React.ReactNode;
}

/** Couverture formation avec repli sur l'image par défaut LyrraOne. */
export function FormationCoverImage({
  coverImageUrl,
  alt = '',
  className,
  fallback,
}: Props) {
  const [src, setSrc] = useState(() => resolveFormationCoverUrl(coverImageUrl));
  const [useFallback, setUseFallback] = useState(false);
  const errorCount = useRef(0);

  useEffect(() => {
    setSrc(resolveFormationCoverUrl(coverImageUrl));
    setUseFallback(false);
    errorCount.current = 0;
  }, [coverImageUrl]);

  if (useFallback && fallback) {
    return <>{fallback}</>;
  }

  if (useFallback && !fallback) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cn('h-full w-full object-cover', className)}
      onError={() => {
        if (errorCount.current === 0) {
          errorCount.current = 1;
          setSrc(DEFAULT_FORMATION_COVER_PATH);
          return;
        }
        setUseFallback(true);
      }}
    />
  );
}
